/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

          var instance = this;
          instance.formId = 0
          instance.overlay = new SUPERSTRONG.Overlayer();

          $('.newsletter-form-trigger').on('click',function (e){
              e.preventDefault();
              instance.overlay.injectNodeSync($('div[data-overlay-ref="newsletter-form"]'));
              instance.overlay.showOverlay();

          });

          $(document.body).delegate('.form-submit','click',function (e){
             $elm = $(e.currentTarget);
             register($elm.closest('form'));
             e.preventDefault();
          })

          $('#grid img').load (function (){

              $('#grid').shuffle('update')

          })
          function register($form) {
            $.ajax({
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
                cache       : false,
                dataType    : 'json',
                contentType: "application/json; charset=utf-8",
                error       : function(err) {console.log ('Error',err); $form.find('#mce-error-response').css('display','block'); },
                success     : function(data) {
                    if (data.result != "success") {
                        $form.find('#mce-error-response').css('display','block');
                    } else {
                        $form.find('#newsletter-form').css('display','none')
                        $form.find('#mce-success-response').css('display','block')
                    }
                }
            });
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        $(document).ready(function (){

            
            $.fn.datepicker.dates['fr'] = {
                days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
                daysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
                daysMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
                months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
                monthsShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                today: "Aujourd'hui",
                clear: "Effacer",
                format: "mm/dd/yyyy",
                titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
                
            };
            var slider = new SUPERSTRONG.Slider();
            var schedule = $('#schedule').datepicker(
                {
                     beforeShowDay:markDateAsScheduled
                    ,language:'fr'
                    ,weekStart: 1
                    ,templates:{
                        leftArrow: '<i class="fa fa-long-arrow-left"></i>'
                        ,rightArrow: '<i class="fa fa-long-arrow-right"></i>'
                    }
                }
            )
            var $eventItem = $("#schedule-event-template").remove();
            var today = new Date();
            var dateOptions = {weekday: "long", year: "numeric", month: "long", day: "numeric"};
            $('#schedule').datepicker('update',today.toISOString());
            $('#current-date').html(setCurrentDate(today))
            feedScheduleEvents(getEventByDate(today));
            $('#grid').shuffle('update');

            function markDateAsScheduled (date){
                
                return getEventByDate(date).length>0 ? "scheduled" : "";

            }

            function setCurrentDate (date){

                return date.toLocaleDateString("fr-FR", dateOptions);

            }

            function getEventByDate (date){

                var  d 
                    ,filtered
                    ;


                filtered = events.filter (function (elm){   
                
                    d = moment(elm.date.date).toDate();
                    d.setHours(0);
                    d.setMinutes(0);
                    d.setSeconds(0);
                    
                    return date.getTime() === d.getTime();

                });

                return filtered;

            }

            $('#schedule').datepicker().on('changeDate',function (e){

                feedScheduleEvents(getEventByDate(e.date));
                $('#current-date').html(setCurrentDate(e.date))

            })

            function feedScheduleEvents (events){

                $('#schedule-events ul').empty();
                var evts = orderEventByHour(events)
                var li;
                for(var i = 0; i<events.length ; i++){

                    li = $eventItem.clone();
                    li.find('p:first-child').html(evts[i].hour);
                    li.find('p+p').html(evts[i].event.post_title);
                    li.find('a').attr('href',evts[i].event.post_link);
                    $('#schedule-events ul').append(li);

                }


            }

            function orderEventByHour (events){

              var sorted = events.sort(function (a,b){

                var a1 = parseInt(a.hour.replace('h',''));
                var b1 = parseInt(b.hour.replace('h',''));
                return a1-b1;

              })

              return sorted

            }

        })
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
